import { getZipAddresses } from '../../api/transport'

// Only the upstream OMS dictionary supplies cities. Never add public-data aliases.
export function createUsZipLookup (load = getZipAddresses) {
  const pending = new Map()
  return function lookup (value) {
    const zip = String(value == null ? '' : value).trim()
    if (!/^[0-9]{5}$/.test(zip)) return Promise.resolve(null)
    if (pending.has(zip)) return pending.get(zip)
    const request = Promise.resolve().then(() => load(zip)).then(data => {
      if (!data || data.zipCode !== zip || !Array.isArray(data.addressList) || data.totalCount !== data.addressList.length) throw new Error('Invalid upstream ZIP response')
      if (!data.addressList.length) return null
      const addresses = data.addressList.map(row => {
        if (!row || typeof row.city !== 'string' || !row.city.trim() || typeof row.stateCode !== 'string' || !row.stateCode.trim()) throw new Error('Invalid upstream address')
        return { city: row.city, state: row.stateCode }
      })
      return { state: addresses[0].state, primaryCity: addresses[0].city, cities: [...new Set(addresses.map(row => row.city))], addresses }
    }).finally(() => pending.delete(zip))
    pending.set(zip, request)
    return request
  }
}

export const lookupUsZip = createUsZipLookup()
